export * from './useProductDetailsContentData';
